import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import { authActions } from "../../store/reducer/authReducer";
import { GROLOG_URL } from "../../constant/apiConstant";
import ModalSuccessDelete from "./ModalSuccessDelete";
import ModalFailedDelete from "./ModalFailedDelete";
import { Modal } from "antd";

const ModalRegenerate = (props) =>{
  let dispatch = useDispatch();
  let { t } = useTranslation();
  return(
    <>
    <Modal
      visible={props.visible}
      closable={false}
      centered={true}
      width="464px"
      footer={null}
    >
      <div className={style.ModalTitle}>Regenerate Report?</div>
      <div className={style.ModalSubTitle}>
        Regenerate report will update with current data
        <br />
        Previous data will be overwritten
      </div>

      <div
        style={{
          justifyItems: "center",
          margin: 0,
          padding: 0,
          display: "flex",
        }}
      >
        <div className="mr-8 ml-5">
          <SecondaryButton
              styles="w-[150px]"
            text={t("USER_DETAIL:CANCEL")}
            action={() => props.action()}
          />
        </div>

        <PrimaryButton
            styles="w-[200px]"
            text={t("Regenerate Report")}
            action={() => props.act()
            }
          />
      </div>
    </Modal>
    </>
  )
}

export default ModalRegenerate